// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCdEbyJtKdAS1byP2SHJQjFsAJdaOQNDoM",
  authDomain: "code-ht.firebaseapp.com",
  projectId: "code-ht",
  storageBucket: "code-ht.firebasestorage.com",
  messagingSenderId: "212840229675",
  appId: "1:212840229675:web:50c567ff4a72072b70f36e",
  measurementId: "G-W1ZFH3VLW3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firestore = getFirestore(app);
const database = getDatabase(app);
const storage = getStorage(app);

export { auth, firestore, database, storage };
